import { Stack, Typography } from "@mui/material";
import { DefaultCard, PageLayout } from "components";
import React from "react";
import Address from "../donatePage/Address";

function ContactPage() {
  return (
    <PageLayout>
      <DefaultCard title="CONTACT">
        <Stack spacing={2}>
          <Typography variant="h4">Address</Typography>
          <Address />
          <Typography variant="caption">817 689-1638</Typography>
          <Typography variant="body2">Email HHSS1954@outlook.com</Typography>
        </Stack>
      </DefaultCard>
    </PageLayout>
  );
}

export default ContactPage;
